var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Box, IconButton, MenuItem, Select, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Frequency, RRule, rrulestr } from "../../utils/rrule";
import TextField from "@mui/material/TextField";
import RemoveIcon from '@mui/icons-material/Remove';
import Typography from "@mui/material/Typography";
import CDatePicker from "../CDatePicker";
import { addHours, isAfter, isBefore } from "../../utils/date.util";
import Property from "../Property";
import CloseIcon from "@mui/icons-material/Close";
var RepeatableEntityConfig = function (_a) {
    var entity = _a.entity, setEntity = _a.setEntity, onClear = _a.onClear, disabled = _a.disabled;
    console.log('entity', entity);
    var t = useTranslation().t;
    var updateField = function (fieldName, value) {
        var _a;
        setEntity(__assign(__assign({}, entity), (_a = {}, _a[fieldName] = value, _a)));
    };
    var rrule;
    if (entity === null || entity === void 0 ? void 0 : entity.rrule) {
        var sourceString = entity.rrule;
        if (!sourceString.startsWith('RRULE:')) {
            sourceString = "RRULE:".concat(sourceString);
        }
        rrule = rrulestr(sourceString, { dtstart: null });
    }
    else {
        rrule = new RRule();
    }
    var repeatUnitLabel = '';
    var repeatFullString = '';
    switch (rrule.options.freq) {
        case Frequency.DAILY:
            repeatUnitLabel = t('Day(s)');
            repeatFullString = "".concat(t('Every'), " ").concat(rrule.options.interval, " ").concat(repeatUnitLabel);
            break;
        case Frequency.WEEKLY:
            repeatUnitLabel = t('Week(s)');
            repeatFullString = "".concat(t('Every'), " ").concat(rrule.options.interval, " ").concat(repeatUnitLabel);
            break;
        case Frequency.MONTHLY:
            repeatUnitLabel = t('Month(s)');
            repeatFullString = "".concat(t('Every'), " ").concat(rrule.options.interval, " ").concat(repeatUnitLabel);
            break;
        case Frequency.YEARLY:
            repeatUnitLabel = t('Year(s)');
            repeatFullString = "".concat(t('Every'), " ").concat(rrule.options.interval, " ").concat(repeatUnitLabel);
            break;
        default:
            // case PlanItemRepeatFrequency.DOES_NOT_REPEAT:
            repeatUnitLabel = t('Day(s)');
            repeatFullString = t('Repeat DOES_NOT_REPEAT');
            break;
    }
    if ((entity === null || entity === void 0 ? void 0 : entity.rrule) === undefined) {
        repeatUnitLabel = '';
    }
    var toogleDay = function (day) {
        rrule.options.byweekday = rrule.options.byweekday || [];
        var isInWeek = !!rrule.options.byweekday.find(function (d) { return d === day; });
        if (!isInWeek) {
            rrule.options.byweekday.push(day);
        }
        else {
            rrule.options.byweekday = rrule.options.byweekday.filter(function (r) { return r !== day; });
        }
    };
    var endOn = rrule.options.until;
    var updateRRuleField = function (fieldName, value) {
        var _a;
        var updatedRrule = new RRule(__assign(__assign({}, rrule.options), (_a = {}, _a[fieldName] = value, _a)));
        var byweekday = updatedRrule.options.byweekday;
        if (fieldName == 'freq' && value != Frequency.WEEKLY) {
            byweekday = null;
        }
        updateField('rrule', RRule.optionsToString({
            freq: updatedRrule.options.freq,
            interval: updatedRrule.options.interval,
            byweekday: byweekday,
            until: updatedRrule.options.until
        }).replace('RRULE:', ''));
    };
    return (_jsxs(Stack, __assign({ gap: 2 }, { children: [_jsx(TextField, { label: t('Name'), value: (entity === null || entity === void 0 ? void 0 : entity.name) || '', onChange: function (e) { return updateField('name', e.target.value); }, size: "small", disabled: disabled, InputProps: {
                    endAdornment: (entity === null || entity === void 0 ? void 0 : entity.name) ? (_jsx(IconButton, __assign({ size: "small", onClick: function () {
                            updateField('name', "Available");
                            onClear();
                        }, sx: { mr: -1.5 } }, { children: _jsx(CloseIcon, {}) }))) : null
                } }), _jsxs(Stack, __assign({ direction: 'row', sx: { alignItems: 'center', gap: 1 } }, { children: [_jsx(CDatePicker, { label: t('Start time'), disabled: disabled, value: entity === null || entity === void 0 ? void 0 : entity.startTime, onChange: function (e) {
                            var newStart = e || undefined;
                            var newEnd = (entity === null || entity === void 0 ? void 0 : entity.endTime) || undefined;
                            if (isAfter(newStart, newEnd)) {
                                newEnd = addHours(newStart, 1);
                            }
                            setEntity(__assign(__assign({}, entity), { startTime: newStart, endTime: newEnd }));
                        } }), _jsx(RemoveIcon, {}), _jsx(CDatePicker, { label: t('End time'), disabled: disabled, value: entity === null || entity === void 0 ? void 0 : entity.endTime, onChange: function (e) {
                            var newStart = (entity === null || entity === void 0 ? void 0 : entity.startTime) || undefined;
                            var newEnd = e || undefined;
                            if (isBefore(newEnd, newStart)) {
                                newStart = addHours(newEnd, -1);
                            }
                            setEntity(__assign(__assign({}, entity), { startTime: newStart, endTime: newEnd }));
                        } })] })), _jsxs(Box, __assign({ sx: {
                    display: 'flex',
                    gap: '12px',
                    flexDirection: 'column'
                } }, { children: [_jsx(Typography, __assign({ variant: "h6" }, { children: t('Repeat') })), _jsxs(Select, __assign({ value: (entity === null || entity === void 0 ? void 0 : entity.rrule) ? rrule.options.freq : -1, disabled: disabled, onChange: function (event) {
                            if (event.target.value === -1) {
                                updateField('rrule', undefined);
                                return;
                            }
                            else {
                                var newFreq = event.target.value;
                                // If switching to weekly and there's a start time, set the day to the start time's weekday
                                if (newFreq === Frequency.WEEKLY && (entity === null || entity === void 0 ? void 0 : entity.startTime)) {
                                    var jsDay = entity.startTime.getDay(); // 0=Sunday, 1=Monday, etc
                                    var rruleDay = (jsDay + 6) % 7; // Convert to RRule format (0=Monday)
                                    var updatedRrule = new RRule(__assign(__assign({}, rrule.options), { freq: newFreq, byweekday: [rruleDay] }));
                                    updateField('rrule', RRule.optionsToString({
                                        freq: updatedRrule.options.freq,
                                        interval: updatedRrule.options.interval,
                                        byweekday: updatedRrule.options.byweekday,
                                        until: updatedRrule.options.until
                                    }).replace('RRULE:', ''));
                                }
                                else {
                                    updateRRuleField('freq', newFreq);
                                }
                            }
                        }, sx: { width: '100%' }, size: 'small' }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: t('Does not repeat') }), -1), [Frequency.DAILY, Frequency.WEEKLY, Frequency.MONTHLY, Frequency.YEARLY].map(function (v) {
                                var name;
                                switch (v) {
                                    case Frequency.DAILY:
                                        name = t('Daily');
                                        break;
                                    case Frequency.WEEKLY:
                                        name = t('Weekly');
                                        break;
                                    case Frequency.MONTHLY:
                                        name = t('Monthly');
                                        break;
                                    case Frequency.YEARLY:
                                        name = t('Yearly');
                                        break;
                                }
                                return (_jsx(MenuItem, __assign({ value: v }, { children: name }), v));
                            })] })), !!(entity === null || entity === void 0 ? void 0 : entity.rrule) && (_jsx(TextField, { sx: { mt: 1 }, label: t("Repeat every"), value: rrule.options.interval || '', onChange: function (e) {
                            updateRRuleField('interval', parseInt(e.target.value));
                        }, size: 'small', type: 'number', disabled: disabled, fullWidth: true, InputProps: {
                            endAdornment: (_jsx(Typography, { children: repeatUnitLabel }))
                        } })), rrule.options.freq === Frequency.WEEKLY && (_jsx(Property, __assign({ title: t('Repeat on') }, { children: _jsxs(ToggleButtonGroup, __assign({ id: 'status', value: rrule.options.byweekday || [], size: 'small', disabled: disabled, onChange: function (e, value) {
                                updateRRuleField('byweekday', value);
                            } }, { children: [_jsx(ToggleButton, __assign({ value: 0 }, { children: t('Mon') })), _jsx(ToggleButton, __assign({ value: 1 }, { children: t('Tue') })), _jsx(ToggleButton, __assign({ value: 2 }, { children: t('Wed') })), _jsx(ToggleButton, __assign({ value: 3 }, { children: t('Thu') })), _jsx(ToggleButton, __assign({ value: 4 }, { children: t('Fri') })), _jsx(ToggleButton, __assign({ value: 5 }, { children: t('Sat') })), _jsx(ToggleButton, __assign({ value: 6 }, { children: t('Sun') }))] })) }))), _jsx(CDatePicker, { label: t('Until'), disabled: disabled, value: rrule.options.until || undefined, onChange: function (e) {
                            updateRRuleField('until', e || null);
                        } })] }))] })));
};
export default RepeatableEntityConfig;
